import { useClientId } from "@/shared/hooks/useClientId";
import { useClientData } from "@/features/projects/contexts/ClientDataContext";
import { ExportsPanel } from "@/features/exports/components/ExportsPanel";
import { ImportSection } from "@/features/exports/components/ImportSection";

export default function ClientExportsPage() {
  const { clientId } = useClientId();
  const { data: clientData } = useClientData();
  const clientName = clientData?.client?.name ?? "Project";

  if (!clientId) return null;

  return (
    <div className="flex-1 flex flex-col overflow-auto p-6 bg-background space-y-8">
      <h1 className="text-2xl font-bold">Import &amp; Export</h1>

      <ImportSection
        scope={{ kind: "project", projectId: clientId }}
        label={clientName}
      />

      <hr className="border-border/40" />

      <section className="space-y-4">
        <h2 className="text-lg font-semibold text-foreground">Export</h2>
        <ExportsPanel
          scope={{ kind: "project", projectId: clientId }}
          label={clientName}
        />
      </section>
    </div>
  );
}
